
import { defineComponent } from "vue";

export default defineComponent({
  name: "TermsOfUse",
  components: {},
  setup() {
    return {};
  },
});
